enum Mode {
  SELECT = 'select',
  PAN = 'pan',
}

export default Mode;
